import { render, staticRenderFns } from "./TransferCourtFee.vue?vue&type=template&id=4bd5b871&"
import script from "./TransferCourtFee.vue?vue&type=script&lang=js&"
export * from "./TransferCourtFee.vue?vue&type=script&lang=js&"
import style0 from "./TransferCourtFee.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports